<template>
  <div>
    <v-dialog
      content-class="dialog-rotate"
      v-if="inRotationMode"
      v-model="dialogRotate"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title>
          Rotación
          <v-spacer></v-spacer>
            <v-btn icon @click="toggleRotationMode" v-if="rotateProgressState!='running'">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>                  
        <JobProgress v-model="rotateProgressState" :job_id="rotateJobId" v-on:done="rotateDone" v-on:error="rotateDone">
          <template v-slot:progress>
            <v-card-text>
              <div class="d-flex justify-center pt-10">
                <v-progress-circular indeterminate :color="'var(--v-primary-base)'" />
              </div>
            </v-card-text>
          </template>
          <template v-slot:quiet>
            <v-card-text>
              <div class="d-flex justify-center pt-10" v-if="rotateJobId">
                <v-progress-circular indeterminate color="secundary" />
              </div>
              <v-row class="pl-4 pr-4 pt-2" v-else>
                <v-col cols="12">
                  <v-btn-toggle
                    class="btn-toogle-rotation d-flex flex-column"
                    mandatory
                    v-model="rotationPageMode"
                    @change="setRotationMode">
                    <v-btn class="mb-6 justify-start btn-rotation" value="all" style="border-color:#65379C !important;">
                      <img class="pa-2" left src="/invoices/rotate_document.png"/>
                      Todo el documento
                    </v-btn>
                    <v-btn class="justify-start btn-rotation" value="page" style="border-color:#65379C !important;">
                      <img class="pa-2" left src="/invoices/rotate_page.png"/>
                      Por página
                    </v-btn>
                  </v-btn-toggle>

                  
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-btn rounded color="primary" outlined @click="cancelRotationMode()">
                Cancelar
              </v-btn>         
              <v-btn 
                rounded 
                color="primary" 
                @click="doRotation()" 
                :disabled="!hasRotationChanges"
              >
                Guardar rotación
              </v-btn>          
            </v-card-actions>

          </template>
        </JobProgress>        
        
      </v-card>
    </v-dialog>

    <div 
      :class="[
          'header-pdf-document --header-pdf-document-custom', 
          { 'mobile-header': is_mobile }
        ]"
    >
      <div>
        <div class="title" v-if="!not_invoice">{{$t("PDFDocumentV2.invoice_detail")}}</div>
        <div class="title" v-else>{{$t("PDFDocumentV2.doc_detail")}}</div>
        <div v-if="folder_route" class="folder-route-label">
          <v-icon x-small class="mr-1">mdi-folder-outline</v-icon>{{ folder_route }}
        </div>
      </div>

      <v-spacer />

      <div class="action-controls">

        <div class="group" v-if="!isMediumScreen">

          <DocumentDownload
            v-if="!not_invoice"
            :currentDocument="currentDocument"
            :key="currentDocument.id"
          />

          <v-tooltip bottom v-if="!not_invoice">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <show-boxes-btn
                  :key="currentDocument.id.toString()"
                  v-if="currentDocument"
                  stylev2
                />
              </div>
            </template>
            <span>Resaltar campos</span>
          </v-tooltip>

          <div v-if="! is_mobile">

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="action-btn-doc" fab small icon :disabled="zoom >= maxZoom" @click="increaseZoom" v-on="on">
                  <AppIcon src="/invoices/zoom_in.svg" :size="24" :preserveColors="true"/>
                </v-btn>
              </template>
              <span>Aumentar zoom</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="action-btn-doc" fab small icon :disabled="zoom <= minZoom" @click="decreaseZoom" v-on="on">
                  <AppIcon src="/invoices/zoom_out.svg" :size="24" :preserveColors="true"/>
                </v-btn>
              </template>
              <span>Disminuir zoom</span>
            </v-tooltip>

            <v-tooltip bottom v-if="!not_invoice">
              <template v-slot:activator="{ on }">
                <v-btn class="action-btn-doc" fab small icon @click="toggleRotationMode" v-on="on">
                  <v-icon>mdi-file-rotate-left-outline</v-icon>
                </v-btn>
              </template>
              <span>Rotar documento</span>
            </v-tooltip>

          </div>
           
          <app-confirm-modal
            v-model="deleteDocumentDialog"
            :text-msg="deleteDocumentMsg"
            @confirm="confirmDeleteDocument()"
            @cancel="noDeleteDocument()"
          >
          </app-confirm-modal>

          <JobProgress v-model="deleteProgressState" :job_id="deleteJobId" v-on:done="deleteItemDone" v-if="!not_invoice">
            <template v-slot:progress>
              <v-btn fab small loading icon />
            </template>

            <template v-slot:quiet>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-btn 
                      v-if="userData && userData.user_role.value != 'customer' && userData.user_role.value != 'customer_consult'"
                      color="primary" 
                      class="action-btn-doc" fab small icon 
                      :loading="deleting || Boolean(deleteJobId)" 
                      @click="confirmDialogDeleteDocument()"
                    >
                      <AppIcon src="/invoices/delete.svg" :size="24" :preserveColors="true"/>  
                    </v-btn>
                  </div>
                </template>
                <span>Eliminar documento</span>
              </v-tooltip>
            </template>

          </JobProgress>

        </div>

        <v-btn v-if="!permission.general.is_customer_consult && !not_invoice"
          class="btn-upload" 
          depressed 
          @click="$router.push({name: 'document-loader', params: {'company_id': currentCompany.id}})"
        >          
          <v-icon height="20" width="20">mdi-file-upload-outline</v-icon>
          {{ uploadInvoiceLabel }}
        </v-btn>

      </div>

    </div>

    <div class="vertical-controls d-flex flex-column" v-if="isMediumScreen">
    
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <show-boxes-btn
              :key="currentDocument.id.toString()"
              v-if="currentDocument"
              stylev2
            />
          </div>
        </template>
        <span>Resaltar campos</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" class="action-btn-doc" fab small icon :disabled="zoom >= maxZoom" @click="increaseZoom" v-on="on">
            <AppIcon src="/invoices/zoom_in.svg" :size="24" :preserveColors="true"/>
          </v-btn>
        </template>
        <span>Aumentar zoom</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" class="action-btn-doc" fab small icon :disabled="zoom <= minZoom" @click="decreaseZoom" v-on="on">
            <AppIcon src="/invoices/zoom_out.svg" :size="24" :preserveColors="true"/>
          </v-btn>
        </template>
        <span>Disminuir zoom</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="action-btn-doc" fab small icon @click="toggleRotationMode" v-on="on">
            <v-icon>mdi-file-rotate-left-outline</v-icon>
          </v-btn>
        </template>
        <span>Rotar documento</span>
      </v-tooltip>

      <DocumentDownload :currentDocument="currentDocument"/>

      <app-confirm-modal
        v-model="deleteDocumentDialog"
        :text-msg="deleteDocumentMsg"
        @confirm="confirmDeleteDocument()"
        @cancel="noDeleteDocument()"
      >
      </app-confirm-modal>

      <JobProgress v-model="deleteProgressState" :job_id="deleteJobId" v-on:done="deleteItemDone" >
        <template v-slot:progress>
          <v-btn fab small loading icon></v-btn>
        </template>
        <template v-slot:quiet>
          <v-btn color="primary" fab small icon :loading="deleting || Boolean(deleteJobId)" @click="confirmDialogDeleteDocument()">
            <AppIcon src="/invoices/delete.svg" :size="24" :preserveColors="true"/>  
          </v-btn>
        </template>
      </JobProgress>

    </div>

    <div 
      v-if="showRotation && !got_feature('feature_pdf_viewer_v3')" 
      class="controls d-flex justify-start" 
      v-bind:style="{'z-index':'210' }"
    >
      <PDFRotationButtons :rotate="rotate" />
    </div>

    <div :class="['wrapper-pdf-document', {'wrapper-pdf-document--mobile' : is_mobile}]" v-if="scroll">
      <ScrollingDocument
        class="pdf-document pdf-document--custom pdf-document--custom2"
        v-bind:style="{ zoom }"
        v-bind="{pages, pageCount, currentPage}"
        v-slot="{page, isPageFocused, isElementFocused}"
        :enable-page-jump="true"
        @page-jump="onPageJump"
        @pages-fetch="onPagesFetch"
        @pages-reset="fitWidth"
        >
        <PDFPageV2
          v-bind="{scale, optimalScale, page, isPageFocused, isElementFocused, pageCount}"
          @page-rendered="onPageRendered"
          @page-errored="onPageErrored"
          @page-focus="onPageFocused"
        />
      </ScrollingDocument>
    </div>

    <div class="wrapper-pdf-document" v-else>
      <!-- chapuza total -->
      <PDFViewerV3 
        :hide_options="true"
        :url="currentDocument.signed_url"
        :key="currentDocument.signed_url"
        class='pdf-document'
      />
    </div>
    
  </div>
</template>

<script>
// PDFDocument renders an entire PDF inline using
// PDF.js and <canvas>. Currently does not support,
// rendering of selected pages (but could be easily
// updated to do so).
import { mapGetters, mapActions } from "vuex"
import {PIXEL_RATIO, VIEWPORT_RATIO, PIXEL_RATIO_DEVICE} from '../utils/constants';

import { client } from "@/api/client";
import ScrollingDocument from './ScrollingDocument';
import ShowBoxesBtn from './ShowBoxesBtn.vue';
import PDFPageV2 from './PDFPageV2';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import JobProgress from '../components/JobProgress.vue'
import PDFViewerV3 from '../components/pdf/PDFViewerV3.vue'
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import { isMobile } from "filestack-js";
import PDFRotationButtons from "./PDFRotationButtons.vue";
import DocumentDownload from "./DocumentDownload.vue";

export default {
  name: 'PDFDocumentV2',
  inject:['runRefreshFuncs'],
  data() {
    return {
      maxZoom: 3,
      minZoom: 0.1,
      deleteDocumentDialog: false,
      deleteDocumentMsg: 'Se va a eliminar el documento.',
      deleteProgressState: 'none',
      deleteJobId: 0,
      deleting: false,
      rotateProgressState: 'none',
      rotationPageMode: 'all',
      dialogRotate: true,
      loading_next: false,
    }
  },

  components: {
    ScrollingDocument,
    PDFPageV2,
    ShowBoxesBtn,
    AppConfirmModal,
    JobProgress,    
    PDFViewerV3,
    PDFRotationButtons,
    DocumentDownload
  },

  props: {
    pages: {
      required: true,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    scale: {
      type: Number,
      default: 1.0,
    },
    optimalScale: {
      type: Number,
    },
    fit: {
      type: String,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    isPreviewEnabled: {
      default: false,
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: undefined,
    },
    not_invoice: {
      type: Boolean,
      default: false,
    },
    folder_route: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters([
      "is_mobile"
    ]),
    ...mapGetters({
      userData: 'me/userData',
      got_feature: 'got_feature'
    }),
    defaultViewport() {
      if (!this.pages.length) return {width: 0, height:0};
      const [page] = this.pages;

      return page.getViewport(1.0);
    },
    isPortrait() {
      const {width, height} = this.defaultViewport;
      return width <= height;
    },
    showRotation() {
      return this.inRotationMode && this.rotationMode === 'all' && this.rotateProgressState !== 'running'
    },
    counterZoom() {
      return 1 / this.zoom
    },
    isMediumScreen() {
      return (this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.md) || false;
    },
    ...mapGetters({
      zoom: "documents/zoom",
      inRotationMode: "documents/inRotationMode",
      rotationMode: "documents/rotationMode",
      rotateJobId:"documents/rotateJobId",      

      currentDocument: "documents/currentDocument",
      currentCompany: "getCurrentCompany",
      userData: 'me/userData',
      permission: 'permissions/permission',
    }),
    ...mapFields('documents',vuexPrefix('document_',['supplierdb_info', 'customerdb_info', 'kind'],'document.')),
    ...mapFields('documents', ['isBienInversionChanged', 'areIvaChecksChanged']),
    uploadInvoiceLabel(){
      return this.is_mobile ? "" : this.$t("PDFDocumentV2.upload_invoice");
    },
    ...mapGetters({
      currentDocuments: "documents/currentDocuments",
      currentIndex: "documents/currentIndex",
      currentPagination: "documents/currentPagination"
    }),
    hasRotationChanges() {
      const perDoc = this.$store.state.documents.rotationPerDocument || []
      return (
        this.$store.state.documents.globalRotation !== 0 ||
        perDoc.some(row => row !== 0)
      )
    }
  },

  methods: {
    ...mapActions({
      setZoom: "documents/setZoom",
      doRotate: 'documents/doRotate',
      downloadFile:"documents/downloadFile",
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
      setRotation:"documents/setRotation",
      setRotationMode:"documents/setRotationMode",
      cancelRotationMode:"documents/cancelRotationMode",
      saveRotation:"documents/saveRotation",
      refreshData:"documents/refreshData"
    }),
    confirmDialogDeleteDocument() {
      this.deleteDocumentDialog = true;
    },
    noDeleteDocument() {
      this.deleteDocumentDialog = false;
    },
    confirmDeleteDocument() {
      this.deleteDocumentDialog = false;
      this.deleting = true;
      client.post("delete_documents/" , { 'doc_ids': [this.currentDocument.id] }).then(resp => {
        if (Object.keys(resp.data).includes('ko')) {
            this.setMessageModal({
              text: resp.data['ko'],
              actionConfirmButton: this.closeMessageModal
            })
            this.deleting = false;
            this.deleteDocumentDialog = false;
        }
        else {
          this.deleteJobId = resp.data['AsyncJob'];
          this.deleteProgressState = 'running';
        }
      });
    },
    next_document() {

      this.loading_next = true;

      if (this.currentIndex + 1 <= this.currentDocuments.length - 1) {
        const nextDoc = this.currentDocuments[this.currentIndex + 1];

        this.$router.push({ name: "document-detail", params: { document: nextDoc.id.toString() } });
        this.$store.dispatch("documents/fetchDocument", { id: nextDoc.id });
        this.$store.dispatch("documents/setCurrentIndex", this.currentIndex + 1);

        this.loading_next = false;

      } else {

        const paginationNext = this.currentPagination && this.currentPagination.next;

        const url = paginationNext && paginationNext.includes('/api')
        ? paginationNext.split('/api').pop()
        : null;

        if (!url) {
          this.$router.push({ name: "document-list" });
          return;
        }

        client.get(url).then(response => {
          this.$store.dispatch("documents/setCurrentDocs", response.data);
          this.$store.dispatch("documents/setCurrentIndex", 0);

          const results = response.data.results;

          if (results.length > 0) {
            const firstDoc = results[0];

            this.$router.push({ name: "document-detail", params: { document: firstDoc.id.toString() } });
            this.$store.dispatch("documents/fetchDocument", { id: firstDoc.id });
          } else {
            this.$router.push({ name: "document-list" });
          }

          this.loading_next = false;
        }).catch(err => {
          this.loading_next = false;
        });
      }
    },
    deleteItemDone() {
      this.deleting = false;
      this.deleteJobId = 0;

      this.setMessageModal({
        text: 'El documento se ha borrado correctamente.',
        actionConfirmButton: this.closeMessageModal
      });

      if (this.currentDocuments && this.currentDocuments.length > 0) return this.next_document();

      this.$router.push({ name: 'document-list' });
    },
    toggleRotationMode() {
      this.setRotation(!this.inRotationMode)      
    },
    rotate(deg) {
      this.doRotate({rotation: deg})
    },
    doRotation() {
      this.saveRotation().then(() => {
        this.rotateProgressState = "running"
      })
    },
    async rotateDone() {

      this.rotateProgressState = 'none'
      this.$store.commit('documents/SET_ROTATION_TASK', null)
      this.cancelRotationMode()

      const currentDoc = this.$store.getters['documents/currentDocument']
      if (currentDoc) {
        await this.$store.dispatch('documents/fetchDocument', { id: currentDoc.id })
        this.runRefreshFuncs(currentDoc.id)
      }
    },
    increaseZoom() {
      const zoom = Math.min(this.zoom + .1, this.maxZoom)
      localStorage.setItem('pdf_zoom', zoom) 
      this.setZoom(zoom)
    },
    decreaseZoom() {
      const zoom = Math.max(this.zoom - .1, this.minZoom)
      localStorage.setItem('pdf_zoom', zoom) 
      this.setZoom(zoom)
    },
    pageWidthScale() {
      const {defaultViewport, $el} = this;
      if (!defaultViewport.width) return 0;
      let ratio = PIXEL_RATIO;
      if (this.permission.is_readonly) {
        ratio = PIXEL_RATIO_DEVICE;
      }
      return ($el.clientWidth * ratio) * VIEWPORT_RATIO / defaultViewport.width;
    },

    pageHeightScale() {
      const {defaultViewport, $el} = this;
      if (!defaultViewport.height) return 0;
      let ratio = PIXEL_RATIO;
      if (this.permission.is_readonly) {
        ratio = PIXEL_RATIO_DEVICE;
      }
      return ($el.clientHeight * ratio) * VIEWPORT_RATIO / defaultViewport.height;
    },
    // Determine an ideal scale using viewport of document's first page, the pixel ratio from the browser
    // and a subjective scale factor based on the screen size.
    fitWidth() {
      const scale = this.pageWidthScale();
      this.updateScale(scale, {isOptimal: !this.optimalScale});
    },

    fitHeight() {
      const scale = this.isPortrait ? this.pageHeightScale() : this.pageWidthScale();
      this.updateScale(scale);
    },

    fitAuto() {
      const scale = Math.min(this.pageWidthScale(), this.pageHeightScale());
      this.updateScale(scale);
    },

    updateScale(scale, {isOptimal = false} = {}) {
      if (!scale) return;
      this.$emit('scale-change', {scale, isOptimal});
    },

    onPageJump(scrollTop) {
      this.$el.scrollTop = scrollTop; // triggers 'scroll' event
    },

    onPagesFetch(currentPage) {
      this.$parent.$emit('pages-fetch', currentPage);
    },

    onPageFocused(pageNumber) {
      this.$parent.$emit('page-focus', pageNumber);
    },

    onPageRendered(payload) {
      this.$parent.$emit('page-rendered', payload);
    },

    onPageErrored(payload) {
      this.$parent.$emit('page-errored', payload);
    },

    // closeModal(modalName) {
    //   this.$modal.hide('modal-supplier');
    // },   
  },

  watch: {
    fit(fit) {
      switch (fit) {
        case 'width':
          this.fitWidth();
          break;

        case 'auto':
          this.fitAuto();
          break;

        default:
          break;
      }
    },
    pageCount: 'fitWidth',
    isPreviewEnabled: 'fitWidth',
  },

  mounted() {
    const savedZoom = parseFloat(localStorage.getItem('pdf_zoom'))
    if (!isNaN(savedZoom)) {
      this.setZoom(savedZoom)
    }
  }
};
</script>

<style>
.header-pdf-document { 
  width: 101.4%;
  height: 80px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  background-color: white;
  border-bottom:1px solid rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);  
  padding-top: 20px;
  padding-bottom:20px;
  display:flex;
  align-items: center;
  padding-left:30px;
  padding-right:20px;
}
.header-pdf-document .title {
  color: var(--v-primaryDark-base);
  font-size:20px;
  font-weight: 700;
}
.header-pdf-document .folder-route-label {
  font-size: 13px;
  font-style: italic;
  color: #888;
  margin-top: 2px;
}
.header-pdf-document .action-controls {
  display:flex;  
}
.header-pdf-document .action-controls .group {
  background-color: #F6F6F6;
  border-radius: 10px;
  display:flex;
  height: 32px;
  margin-left:10px;
}
.header-pdf-document .action-controls .action-btn-doc {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 10px;
  background-color: #F6F6F6;
}
.header-pdf-document .action-controls .action-btn-doc:hover {
  background-color: #D1D1D1;
}
.header-pdf-document .action-controls .group > .action-btn-doc:not(:last-child) {
  margin-right:5px;
}

.wrapper-pdf-document {
  position: absolute;
  flex: 1 1 auto;
  width: 100%;
  max-height: -webkit-fill-available;
  height: 100%;
  overflow: auto;
}

.vertical-controls {
  position: absolute;
  border: 2px solid var(--v-primary-base);
  border-radius: 5px;
  background-color: #FFFFFF;
  z-index: 100;
  margin-top: 20%;
  left: auto;  
  right: 20px;
  width: 36px;
}
.vertical-controls .v-btn--fab {
  width: 32px;
  height: 32px;
}
.controls {
  position: absolute;
  z-index: 100;
  margin-top: 15px;
  left: 15px;
}
.controls-end {
  left: auto;
  right: 30px;
}
.controls button {
  background-color: white;
}

.scrolling-page {
  margin-bottom: 1em;
}

.dialog-rotate {
    border: 1px solid #65379C !important;
    border-radius: 10px !important;    
}
.dialog-rotate .v-card__title {
  border-bottom: 1px solid #65379C;
  color: #65379C;
}
.dialog-rotate .v-card__title .v-icon {
  color: #65379C;
}
.dialog-rotate .v-card__actions {
  padding: 16px 24px;
  justify-content: space-around;
}
.dialog-rotate .v-card__actions .v-btn {
  font-size:11px;
  padding-left: 20px;
  padding-right:20px;
}

.btn-toogle-rotation .v-btn {
  border:1px solid #65379C !important;    
  border-radius: 5px !important;
  background-color: white !important;
  color:#56565B;
  text-transform: capitalize !important;
  font-weight: 300;
  height: 40px !important;
}
.btn-toogle-rotation > .v-btn.v-btn--active {
  background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white) !important;
  font-weight: 400;
}

@media print {
  .pdf-document {
    position: static;
  }
}
</style>

<style scoped>
  .scrollable-card {
    /* height:600px; 
    width:1000px;  */
    height:100%; 
    width:100%;
    overflow: auto;
  }
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }  
 
  .header-pdf-document .action-controls .btn-upload {
    border-radius:10px;
    background-color: #F9F6FE !important;
    color: var(--v-primary-base);
    border:1px solid var(--v-primary-base);
    text-transform:capitalize;
    letter-spacing: 1px;
    height: 32px;
    margin-left:10px;
  }
  .header-pdf-document .action-controls .btn-upload .v-icon {
    font-size:20px;
  }
</style>

<!-- Mobile -->
<style scoped>
.mobile-header {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    border-top-left-radius: 0px; 
    border-top-right-radius: 0px;

    .v-btn:not(.v-btn--round).v-size--default{
      padding: 4px !important;
      min-width: none;
    }

    .action-controls {
        padding: 5px;
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: center;
        justify-content: space-around;
        align-items: center;

        .group {
            margin-left: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            align-content: center;
            flex-wrap: nowrap;

            .action-btn-doc:not(:last-child){
              margin-right: 0;
            }
        }

        .btn-upload{
          margin-left: 0;
        }
    }
}
</style>

<style>
  .header-pdf-document.mobile-header {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
</style>

<style>
@media (max-width: 965px) {
  .container.container--fluid {
    padding: 0 !important;
  }
}
</style>

<style>
.v-main {
  overflow: hidden;

  .container {
    padding: unset !important;
  }
}

.--header-pdf-document-custom{
  width: 99% !important;
}

.pdf-document--custom2 {
  width: 99% !important;
}
</style>

<style>

/* Firefox specific styles */
@-moz-document url-prefix() {

  .wrapper-pdf-document {
    height: 90% !important;
  }

  .pdf-paginator {
    bottom: 0.8% !important;
  }

  @media screen and (min-width: 1024px) and (max-width: 1720px) {
    .wrapper-pdf-document {
      height: 88% !important;
    }
  }

  @media screen and (max-width: 1023px) {
    .wrapper-pdf-document {
      height: 85% !important;
    }
  }
}

.btn-no-zoom {
  zoom: 1 !important;
}

</style>